import React, { useEffect } from 'react';
import { motion } from 'framer-motion';

const RefundPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen pb-24 pt-48">
      <div className="max-w-4xl mx-auto px-4 md:px-8 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-4xl md:text-5xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Refund Policy
          </h1>
          <p className="text-sm mb-12 opacity-70">Effective Date: April 2026</p>

          <div className="prose prose-lg max-w-none space-y-8">
            <p>
              At Ricky's Bees, we take pride in delivering high-quality honey products. If something isn't right, we're here to help.
            </p>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>1. Change of Mind</h2>
              <p>Due to the nature of food products, we do not accept returns for change of mind.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>2. Damaged or Faulty Products</h2>
              <p className="mb-4">If your order arrives damaged or faulty, you are entitled to a replacement or refund under Australian Consumer Law.</p>
              <p className="mb-4">To request this:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Contact us within 7 days of delivery</li>
                <li>Provide your order number and clear photos of the issue</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>3. Incorrect Items</h2>
              <p>If you receive the wrong product, please contact us within 7 days and we will arrange a replacement or refund.</p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>4. Refund Process</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Approved refunds will be issued to your original payment method</li>
                <li>Processing times may vary depending on your bank/provider</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>5. Non-Returnable Items</h2>
              <p className="mb-4">We cannot accept returns for:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Opened or used food products (unless faulty)</li>
                <li>Change of mind purchases</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>6. Contact Us</h2>
              <p>Email: <a href="mailto:sales@rickysbees.com.au" className="text-primary hover:underline">sales@rickysbees.com.au</a></p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default RefundPolicy;
